import { windowWidth } from "@styles/global";
import Login from "@assets/Backgrounds/Login.svg";
import LoginMobile from "@assets/Backgrounds/LoginMobile.svg";
import styled from "styled-components";
import TravelSharing from "@pages/TravelSharing/index";

const TravelSharingContainer = styled.div`
  background: url(${Login});
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: auto;

  /* @media (max-width: ${windowWidth.tablet}) {
    background: url(${LoginMobile}) #008D36;
    background-position: center;
    background-size: cover;
    background-blend-mode: multiply;
  } */
`;

const LoginFormContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  flex-direction: column;

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 90%;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export { TravelSharingContainer, LoginFormContainer };
